import Box from '@/common/components/Box'
import ResumeItem from '@/common/components/ResumeItem'
import { formatDateTime } from '@/common/utils/formatters'
import { MaintenanceForwardingsDirectiveEntryKlass } from '@/features/maintenanceWorkflow/pages/Show/features/forwardings/constants/maintenanceForwardingsDirectiveEntryKlasses.type'
import {
  MaintenanceForwardingDirectiveEntryStatus,
  MaintenanceForwardingStatus,
} from '@/features/maintenanceWorkflow/pages/Show/features/forwardings/types/maintenanceForwarding.type'
import { useForwardingTabContext } from '@/features/maintenanceWorkflow/pages/Show/hooks/forwardings/useForwardingTabContext'
import { useMemo } from 'react'

const MaintenanceWorkflowForwardingDirectiveEntrySectionExecutionEntry = () => {
  const { forwarding, forwardingUpdatedAt } =
    useForwardingTabContext<MaintenanceForwardingsDirectiveEntryKlass.ExecutionEntry>()

  const isAwaitingCheckin = useMemo(() => {
    return forwarding?.status === MaintenanceForwardingStatus.OnGoingCheckin
  }, [forwardingUpdatedAt])

  const isAwaitingEndOfMaintenance = useMemo(() => {
    return (
      !isAwaitingCheckin &&
      forwarding?.directive_entry?.status &&
      [
        MaintenanceForwardingDirectiveEntryStatus.AwaitingManualStart,
        MaintenanceForwardingDirectiveEntryStatus.InProgress,
      ].includes(forwarding?.directive_entry?.status)
    )
  }, [forwardingUpdatedAt])

  return (
    <Box className="p-4 flex flex-col gap-4">
      <div className="flex items-center justify-between">
        <div className="flex flex-col">
          <p className="text-lg font-semibold">Execução da manutenção</p>
        </div>

        {isAwaitingCheckin && (
          <div>
            <p className="text-warning">Aguardando Check-in</p>
          </div>
        )}

        {isAwaitingEndOfMaintenance && (
          <div>
            <p className="text-warning">Aguardando fim da manutenção</p>
          </div>
        )}
      </div>

      {(forwarding?.checkin_entry?.completed_at || forwarding?.checkin_entry?.responsible) && (
        <div className="flex gap-3">
          {forwarding?.checkin_entry?.completed_at && (
            <ResumeItem
              label="Check-in realizado"
              value={formatDateTime(new Date(forwarding?.checkin_entry?.completed_at))}
              className="text-xs"
              valueClassName="font-bold text-sm"
            />
          )}

          {forwarding?.checkin_entry?.responsible && (
            <ResumeItem
              label="Responsável por Transporte"
              value={forwarding?.checkin_entry?.responsible.full_name || '--'}
              className="text-xs"
              valueClassName="font-bold text-sm"
            />
          )}
        </div>
      )}
    </Box>
  )
}

export default MaintenanceWorkflowForwardingDirectiveEntrySectionExecutionEntry
